module.exports = __webpack_public_path__ + "assets/img/btn-view-bf68b5ee.png";